import { useCallback, useMemo } from 'react';
import ppmFavicon from '../../../../../assets/img/logo/ppmfavicon.png';
import { NewPage } from '../../../../../utilities/new-page';
import { webPagePath } from '../../../../../models/web-page-path';
import { useAppSelector } from '../../../../../app/hooks';
import { useParams } from 'react-router-dom';
import { PathParams } from '../../../../../routes/routing-path';
import * as lodash from 'lodash';
import './print-select-images.header.scss';
import { PrintDataStructure, PrintItemDataEntity } from '../../../../../models/sift/json/print-model';

type Props = {
  structure?: PrintDataStructure,
  rightContent?: React.ReactNode,
}
export const PrintSelectImagesHeader = (props: Props) => {
  const {
    structure,
    rightContent,
  } = props;
  const { kijshopCd, shopOrderId } = useParams<PathParams>();
  const {
    currentMeta,
    masterShopList,
  } = useAppSelector((state) => ({
    currentMeta: state.print.printShopOrderMeta[shopOrderId],
    masterShopList: state.common.data.masterShop?.lnwMasterShop.shop?.[0].shopData,
  }), lodash.isEqual);

  const viewData = useMemo(() => {
    const name = currentMeta?.lastName ?? '';
    if (!structure || !currentMeta) {
      return { name: '', shop: '' };
    }
    const shop = (() => {
      const delivery = structure?.deliveryData;
      if (delivery?.type === 'shop') {
        return masterShopList?.find((v) => v.$.shopCode === delivery?.shopCode)?.name?.[0].$.lastName ?? '';
      } else if (delivery?.type === 'customer') {
        return '個別配送'
      } else {
        return '';
      }
    })();
    return {
      name,
      shop,
    }
  }, [currentMeta, structure, masterShopList]);

  const handleClickHelp = useCallback(() => {
    NewPage.tab(webPagePath.help);
  }, []);
  return (
    <div
      className="print_select_images_header"
    >
      <div className="print_select_images_header__left">
        <div className="print_select_images_header__logo">
          <img
            src={ppmFavicon}
            alt=""
          />
        </div>

        {/* メニューリスト閉じる用背景 */}

        <div className="print_select_images_header__menu menu_help">
          <span
            onClick={() => handleClickHelp()}
          >
            ヘルプ
          </span>
        </div>
        <div className="print_select_images_header__space" />
        <div>
          <div>【お客様名】&nbsp;{viewData.name}</div>
          <div>【配送店舗】&nbsp;{viewData.shop}</div>
        </div>
      </div>
      <div className="print_select_images_header__right">
        {rightContent ?? <></>}
      </div>
    </div>
  );
}